"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.objEquals = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var objEquals = function objEquals(a, b) {
  // Create arrays of property names
  var aProps = a ? Object.getOwnPropertyNames(a) : [];
  var bProps = b ? Object.getOwnPropertyNames(b) : []; // If number of properties is different,
  // objects are not equivalent

  if (aProps.length != bProps.length) {
    return false;
  }

  for (var i = 0; i < aProps.length; i++) {
    var propName = aProps[i]; // If values of same property are not equal,
    // objects are not equivalent

    if (_typeof(a[propName]) === "object" && _typeof(b[propName]) === "object") {
      if (!objEquals(a[propName], b[propName])) {
        return false;
      }
    } else if (a[propName] !== b[propName]) {
      return false;
    }
  } // If we made it this far, objects
  // are considered equivalent


  return true;
};

exports.objEquals = objEquals;